import React, { useEffect, useState } from "react";
import { Button } from "../../primary";
import styles from "./viewTreatment.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { Confirmation } from "../../secondary/Confirmation/confirmation";
import warning from "../../../static/images/icon-check-danger.png";
import { setTreatmentViewData } from "../../../app/patientSlice";
import ViewTreatmentForm from "./viewTreatmentForm";
import { TreatmentEditForm } from "./treatmentEditForm";
import { useLoading } from "../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../constants/loadingKeys";
import { Spinner } from "../Loader/Spinner";
import { usePermissions } from "../../../hooks/usePermissions";
import { SectionBanners } from "../SectionBanners";
import { EditActionButton } from "../EditActionButton/EditActionButton";
import { signedLockedAccess } from "../../../utils";
import { PERMISSIONS } from "../../../constants/permissions";

export const ViewTreatMent = ({
  editData,
  viewData,
  saveData,
  noDataMessage,
  viewScreen,
  dressing,
  setCloseWarningSec,
  dropValue,
  setGetValueDrop,
}) => {
  const dispatch = useDispatch();

  const { hasPermission } = usePermissions();
  const assessmentDetails = useSelector((state) => state.patient.detailAssessment);

  const [editable, setEditable] = useState(false);
  const [formChangesConfirm, setFormChangesConfirm] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const [isPrimSec, setIsPrimSec] = useState(false);

  const isTreatmentDataLoading = useLoading(LOADING_KEYS.TREATMENT_KEY);

  const confirmationClose = () => {
    setConfirmationModal(false);
    setClickCancel(false);
  };

  const yesConfirmationModalClick = () => {
    setConfirmationModal(false);
    setEditable(false);
    setFormChangesConfirm(false);
    setClickCancel(false);
  };

  useEffect(() => {
    if (editable) {
      if (formChangesConfirm && clickCancel) {
        setConfirmationModal(true);
      } else if (clickCancel && formChangesConfirm === false) {
        setClickCancel(false);
        setConfirmationModal(false);
        setEditable(false);
      }
    }
  }, [formChangesConfirm, clickCancel, editable]);

  const handleEdit = () => {
    setClickCancel(false);
    setFormChangesConfirm(false);
    setEditable(true);
    if (Array.isArray(viewData) && viewData.length > 0) {
      dispatch(setTreatmentViewData(viewData));
    }
  };

  const handleCancel = () => {
    setClickCancel(true);
  };

  return (
    <>
      {confirmationModal && (
        <Confirmation onClose={() => confirmationClose()} title={" "}>
          <div className="text-center pr-5 pl-5">
            <p>
              <img src={warning} alt="warnning-icon" />
            </p>
            <p className="pb-3">All progress in this section will be lost. Are you sure want to cancel?</p>
            <div className="mb-2">
              <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${styles.yes_btn}` }} onClick={() => yesConfirmationModalClick()} />
              <Button id="closeId" value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${styles.no_btn}` }} onClick={() => confirmationClose()} />
            </div>
          </div>
        </Confirmation>
      )}
      <SectionBanners />
      <div className={`col-md-12 ${styles.treatment_container}`}>
        {isTreatmentDataLoading && <Spinner />}
        {viewData?.length > 0 && !isTreatmentDataLoading && !editable && signedLockedAccess(assessmentDetails?.assessmentStage) && (
          <div className={styles.form_actions}>
            <EditActionButton onClick={handleEdit} disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT)} />
          </div>
        )}
        {!isTreatmentDataLoading && (
          <div className={`p-0 ${styles.patient_content}`}>
            {Array.isArray(viewData) && viewData.length > 0 && !editable ? (
              <ViewTreatmentForm viewData={viewData} editData={editData} dressing={dressing} />
            ) : (
              <TreatmentEditForm
                editData={editData}
                setFormChangesConfirm={setFormChangesConfirm}
                isPrimSec={isPrimSec}
                setIsPrimSec={setIsPrimSec}
                saveData={saveData}
                setEditable={setEditable}
                dressing={dressing}
                setCloseWarningSec={setCloseWarningSec}
                viewScreen={viewScreen}
                dropValue={dropValue}
                setGetValueDrop={setGetValueDrop}
                handleCancel={handleCancel}
                hasPermission={hasPermission}
              />
            )}
          </div>
        )}
        {editData?.length === 0 ? <div className={`${styles.cat}`}>{noDataMessage}</div> : ""}
      </div>
    </>
  );
};
